import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import Loading from '@components/common/loading';
import apiConfig from '@constants/apiConfig';
import useFetch from '@hooks/useFetch';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { showSucsessMessage } from '@services/notifyService';
import { parseJson } from '@utils';
import { Card } from 'antd';

import TableSettingForm from './TableSettingForm';

const TableSettingPage = () => {
    const translate = useTranslate();

    const { restaurantId } = useParams();
    const [ isGetDetailLoading, setIsGetDetailLoading ] = useState(false);
    const [ dataDetail, setDataDetail ] = useState({});
    const [ isChangedFormValues, setIsChangedFormValues ] = useState(false);

    const getDetail = (restaurantId) => {
        setIsGetDetailLoading(true);
        executeGet({
            pathParams: { id: restaurantId },
            onCompleted: (response) => {
                const mappedData = getDataDetailMapping(response.data);
                setDataDetail(mappedData);
                setIsGetDetailLoading(false);
            },
            onError: () => {
                setIsGetDetailLoading(false);
            },
        });
    };

    const prepareUpdateData = (settingObj) => {
        const newSettingObj = {
            ...dataDetail.settings,
            ...settingObj,
        };

        newSettingObj.tableSetting.options = newSettingObj.tableSetting.options.map(
            ({ value, symbol, color }) =>
                `${value}::::${symbol}::::${typeof color === 'object' ? color.color.replace('#', '') : color || ''}`,
        );

        return { ...dataDetail, settings: JSON.stringify(newSettingObj) };
    };

    const getDataDetailMapping = (data) => {
        const dataDetail = { ...data };
        dataDetail.settings = parseJson(data.settings) || {};
        !dataDetail.settings.tableSetting && (dataDetail.settings.tableSetting = {});
        !dataDetail.settings.tableSetting.options && (dataDetail.settings.tableSetting.options = []);
        if (dataDetail.settings?.tableSetting.time_wait_for_notify_order === undefined) {
            dataDetail.settings.tableSetting.time_wait_for_notify_order = 5;
        }
        dataDetail.settings.tableSetting.options = dataDetail.settings.tableSetting.options.map((option) => {
            const [ value = '', symbol = '', color = '' ] = (option || '').split('::::');
            return { value, symbol, color };
        });
        return dataDetail;
    };

    const onSave = (values) => {
        const updatedData = prepareUpdateData(values);
        update({
            data: updatedData,
            onCompleted: (res) => {
                showSucsessMessage(translate.formatMessage(commonMessage.updateRestaurantSuccess), translate);
                executeGet({
                    pathParams: { id: restaurantId },
                    onCompleted: (response) => {
                        const mappedData = getDataDetailMapping(response.data);
                        setDataDetail(mappedData);
                        setIsGetDetailLoading(false);
                    },
                });
            },
            onError: () => {},
        });
    };

    const { execute: executeGet, loading } = useFetch(apiConfig.restaurant.getById, {
        immediate: false,
    });

    const { execute: update, loading: loadingUpdate } = useFetch(apiConfig.restaurant.updateByCustomer);

    useEffect(() => {
        if (restaurantId) {
            getDetail(restaurantId);
        }
    }, [ restaurantId ]);

    const renderActions = () => {
        return [];
    };

    const getFormId = () => {
        return 'table-setting-form';
    };

    if (isGetDetailLoading) {
        return <Loading />;
    }

    return (
        <PageWrapper loading={loading} routes={[ { breadcrumbName: 'Table' } ]}>
            <div className="basic-form-page">
                <Card title="Table Settings" bordered={false} actions={renderActions()}>
                    <TableSettingForm
                        formId={getFormId()}
                        onSubmit={onSave}
                        settingObj={dataDetail.settings || {}}
                        setIsChangedFormValues={setIsChangedFormValues}
                        isChangedFormValues={isChangedFormValues}
                        loadingUpdate={loadingUpdate}
                    />
                </Card>
            </div>
        </PageWrapper>
    );
};

export default TableSettingPage;
